/* The upload size limits, apart from the downscaler so screens can read them without it
   (downscale.ts is its own chunk, loaded at the first upload: lib/image/index.ts). */
/** ID photos and extra documents: the vision model's own limit. */
export const DOCUMENT_MAX_SIDE = 2048;
/** Boarding passes (and the default): room for zxing to read a PDF417 from a photo. */
export const BARCODE_MAX_SIDE = 3072;
/** Under this, a file goes up as it is: re-encoding saves seconds at most. */
export const SMALL_FILE_BYTES = 600 * 1024;
